import { smallestBBox, SlicePolygon, rayPolygonIntersection, getByIndex, Vectors } from "@project-rouge/rg-three";
import { Vector3 } from "three";
import { getClockwisePolygon } from "./index46.js";
import { SplitDirection } from "./index185.js";
function SplitPolyByBBox(polygon, ratio, direction) {
  polygon = getClockwisePolygon(polygon);
  const bBox = smallestBBox(polygon);
  let line1 = bBox.maxSides[0];
  let line2 = bBox.maxSides[1];
  if (direction === SplitDirection.longitudinal) {
    line1 = bBox.minSides[0];
    line2 = bBox.minSides[1];
  }
  const vecPolygon = polygon.map((p) => new Vector3(...p));
  const p1 = pointAlongLine(line1.start, line1.end, ratio);
  const p2 = pointAlongLine(line2.start, line2.end, ratio);
  const dir = p2.clone().sub(p1).normalize();
  const ray = { start: p1, dir };
  let count = 1;
  let delta = Infinity;
  const tolSquared = 0.1;
  const newRay = getAverageEdgeDir(vecPolygon, ray);
  while (delta > tolSquared) {
    if (count > 1e3)
      break;
    const { start: updateStart, dir: updateDir } = getAverageEdgeDir(vecPolygon, newRay);
    count++;
    newRay.start.multiplyScalar((count - 1) / count).addScaledVector(updateStart, 1 / count);
    newRay.dir.multiplyScalar((count - 1) / count).addScaledVector(updateDir, 1 / count);
    delta = newRay.start.distanceToSquared(updateStart);
  }
  const tempPolygons = SlicePolygon({ polygon: vecPolygon, ray: newRay });
  return tempPolygons;
}
function pointAlongLine(start, end, ratio = 0.5) {
  return start.clone().add(end.clone().sub(start.clone()).multiplyScalar(ratio));
}
function getAverageEdgeDir(polygon, ray) {
  const intersections = rayPolygonIntersection({ polygon, ray });
  const averageDir = new Vector3();
  const averagePoint = new Vector3();
  for (const int of intersections) {
    const edgeEnd = getByIndex(polygon, int.index + 1);
    const edgeStart = getByIndex(polygon, int.index);
    const edgePerp = edgeEnd.clone().sub(edgeStart).normalize().cross(Vectors.Up);
    if (edgePerp.dot(ray.dir) < 0)
      edgePerp.negate();
    averageDir.add(edgePerp);
    averagePoint.add(int.point);
  }
  averageDir.normalize();
  averagePoint.multiplyScalar(1 / intersections.length);
  const averageRay = { start: averagePoint, dir: averageDir };
  return averageRay;
}
export {
  SplitPolyByBBox
};
//# sourceMappingURL=index232.js.map
